import { FormattedMessage } from "react-intl";

import { BasePage } from "@/components/base-page";
import { TenantDetails } from "@/features/tenant";

export function TenantDashboardPage() {
  return (
    <BasePage
      activeSidebarButton="dashboard"
      pageSubTitle={<FormattedMessage id="page_title.dashboard" defaultMessage="Dashboard" />}
    >
      <TenantDetails />
    </BasePage>
  );
}
